import { ValueOfKey } from '../../utils-types';

export const SCAN_IQ_PROFILE_TABS = {
  PROFILE: 'PROFILE',
  IN_BODY_INDICATORS: 'IN_BODY_INDICATORS',
};

export type ScanIqProfileTab = ValueOfKey<typeof SCAN_IQ_PROFILE_TABS>;
